module.exports = __webpack_public_path__ + "img/tl.540973db.png";